// Country dial codes (alpha-3 ISO). Gulf/MENA region listed first for the H@H
// deployment, then the rest alphabetically. `iso3` is the alpha-3 country code.
export const DIAL_CODES = [
  { code: "+966", country: "Saudi Arabia", iso3: "SAU" },
  { code: "+971", country: "United Arab Emirates", iso3: "ARE" },
  { code: "+965", country: "Kuwait", iso3: "KWT" },
  { code: "+973", country: "Bahrain", iso3: "BHR" },
  { code: "+974", country: "Qatar", iso3: "QAT" },
  { code: "+968", country: "Oman", iso3: "OMN" },
  { code: "+20", country: "Egypt", iso3: "EGY" },
  { code: "+962", country: "Jordan", iso3: "JOR" },
  { code: "+961", country: "Lebanon", iso3: "LBN" },
  { code: "+963", country: "Syria", iso3: "SYR" },
  { code: "+967", country: "Yemen", iso3: "YEM" },
  { code: "+964", country: "Iraq", iso3: "IRQ" },
  { code: "+970", country: "Palestine", iso3: "PSE" },
  { code: "+249", country: "Sudan", iso3: "SDN" },
  { code: "+93", country: "Afghanistan", iso3: "AFG" },
  { code: "+355", country: "Albania", iso3: "ALB" },
  { code: "+213", country: "Algeria", iso3: "DZA" },
  { code: "+54", country: "Argentina", iso3: "ARG" },
  { code: "+374", country: "Armenia", iso3: "ARM" },
  { code: "+61", country: "Australia", iso3: "AUS" },
  { code: "+43", country: "Austria", iso3: "AUT" },
  { code: "+994", country: "Azerbaijan", iso3: "AZE" },
  { code: "+880", country: "Bangladesh", iso3: "BGD" },
  { code: "+375", country: "Belarus", iso3: "BLR" },
  { code: "+32", country: "Belgium", iso3: "BEL" },
  { code: "+229", country: "Benin", iso3: "BEN" },
  { code: "+591", country: "Bolivia", iso3: "BOL" },
  { code: "+387", country: "Bosnia and Herzegovina", iso3: "BIH" },
  { code: "+267", country: "Botswana", iso3: "BWA" },
  { code: "+55", country: "Brazil", iso3: "BRA" },
  { code: "+359", country: "Bulgaria", iso3: "BGR" },
  { code: "+226", country: "Burkina Faso", iso3: "BFA" },
  { code: "+855", country: "Cambodia", iso3: "KHM" },
  { code: "+237", country: "Cameroon", iso3: "CMR" },
  { code: "+1", country: "Canada", iso3: "CAN" },
  { code: "+235", country: "Chad", iso3: "TCD" },
  { code: "+56", country: "Chile", iso3: "CHL" },
  { code: "+86", country: "China", iso3: "CHN" },
  { code: "+57", country: "Colombia", iso3: "COL" },
  { code: "+243", country: "Congo (DRC)", iso3: "COD" },
  { code: "+506", country: "Costa Rica", iso3: "CRI" },
  { code: "+385", country: "Croatia", iso3: "HRV" },
  { code: "+53", country: "Cuba", iso3: "CUB" },
  { code: "+357", country: "Cyprus", iso3: "CYP" },
  { code: "+420", country: "Czechia", iso3: "CZE" },
  { code: "+45", country: "Denmark", iso3: "DNK" },
  { code: "+253", country: "Djibouti", iso3: "DJI" },
  { code: "+1809", country: "Dominican Republic", iso3: "DOM" },
  { code: "+593", country: "Ecuador", iso3: "ECU" },
  { code: "+503", country: "El Salvador", iso3: "SLV" },
  { code: "+372", country: "Estonia", iso3: "EST" },
  { code: "+251", country: "Ethiopia", iso3: "ETH" },
  { code: "+358", country: "Finland", iso3: "FIN" },
  { code: "+33", country: "France", iso3: "FRA" },
  { code: "+995", country: "Georgia", iso3: "GEO" },
  { code: "+49", country: "Germany", iso3: "DEU" },
  { code: "+233", country: "Ghana", iso3: "GHA" },
  { code: "+30", country: "Greece", iso3: "GRC" },
  { code: "+502", country: "Guatemala", iso3: "GTM" },
  { code: "+504", country: "Honduras", iso3: "HND" },
  { code: "+852", country: "Hong Kong", iso3: "HKG" },
  { code: "+36", country: "Hungary", iso3: "HUN" },
  { code: "+354", country: "Iceland", iso3: "ISL" },
  { code: "+91", country: "India", iso3: "IND" },
  { code: "+62", country: "Indonesia", iso3: "IDN" },
  { code: "+98", country: "Iran", iso3: "IRN" },
  { code: "+353", country: "Ireland", iso3: "IRL" },
  { code: "+39", country: "Italy", iso3: "ITA" },
  { code: "+225", country: "Ivory Coast", iso3: "CIV" },
  { code: "+81", country: "Japan", iso3: "JPN" },
  { code: "+7", country: "Kazakhstan", iso3: "KAZ" },
  { code: "+254", country: "Kenya", iso3: "KEN" },
  { code: "+996", country: "Kyrgyzstan", iso3: "KGZ" },
  { code: "+371", country: "Latvia", iso3: "LVA" },
  { code: "+218", country: "Libya", iso3: "LBY" },
  { code: "+370", country: "Lithuania", iso3: "LTU" },
  { code: "+352", country: "Luxembourg", iso3: "LUX" },
  { code: "+261", country: "Madagascar", iso3: "MDG" },
  { code: "+60", country: "Malaysia", iso3: "MYS" },
  { code: "+960", country: "Maldives", iso3: "MDV" },
  { code: "+223", country: "Mali", iso3: "MLI" },
  { code: "+356", country: "Malta", iso3: "MLT" },
  { code: "+222", country: "Mauritania", iso3: "MRT" },
  { code: "+52", country: "Mexico", iso3: "MEX" },
  { code: "+373", country: "Moldova", iso3: "MDA" },
  { code: "+976", country: "Mongolia", iso3: "MNG" },
  { code: "+382", country: "Montenegro", iso3: "MNE" },
  { code: "+212", country: "Morocco", iso3: "MAR" },
  { code: "+258", country: "Mozambique", iso3: "MOZ" },
  { code: "+95", country: "Myanmar", iso3: "MMR" },
  { code: "+264", country: "Namibia", iso3: "NAM" },
  { code: "+977", country: "Nepal", iso3: "NPL" },
  { code: "+31", country: "Netherlands", iso3: "NLD" },
  { code: "+64", country: "New Zealand", iso3: "NZL" },
  { code: "+505", country: "Nicaragua", iso3: "NIC" },
  { code: "+227", country: "Niger", iso3: "NER" },
  { code: "+234", country: "Nigeria", iso3: "NGA" },
  { code: "+389", country: "North Macedonia", iso3: "MKD" },
  { code: "+47", country: "Norway", iso3: "NOR" },
  { code: "+92", country: "Pakistan", iso3: "PAK" },
  { code: "+507", country: "Panama", iso3: "PAN" },
  { code: "+595", country: "Paraguay", iso3: "PRY" },
  { code: "+51", country: "Peru", iso3: "PER" },
  { code: "+63", country: "Philippines", iso3: "PHL" },
  { code: "+48", country: "Poland", iso3: "POL" },
  { code: "+351", country: "Portugal", iso3: "PRT" },
  { code: "+40", country: "Romania", iso3: "ROU" },
  { code: "+7", country: "Russia", iso3: "RUS" },
  { code: "+250", country: "Rwanda", iso3: "RWA" },
  { code: "+221", country: "Senegal", iso3: "SEN" },
  { code: "+381", country: "Serbia", iso3: "SRB" },
  { code: "+232", country: "Sierra Leone", iso3: "SLE" },
  { code: "+65", country: "Singapore", iso3: "SGP" },
  { code: "+421", country: "Slovakia", iso3: "SVK" },
  { code: "+386", country: "Slovenia", iso3: "SVN" },
  { code: "+252", country: "Somalia", iso3: "SOM" },
  { code: "+27", country: "South Africa", iso3: "ZAF" },
  { code: "+82", country: "South Korea", iso3: "KOR" },
  { code: "+211", country: "South Sudan", iso3: "SSD" },
  { code: "+34", country: "Spain", iso3: "ESP" },
  { code: "+94", country: "Sri Lanka", iso3: "LKA" },
  { code: "+46", country: "Sweden", iso3: "SWE" },
  { code: "+41", country: "Switzerland", iso3: "CHE" },
  { code: "+886", country: "Taiwan", iso3: "TWN" },
  { code: "+992", country: "Tajikistan", iso3: "TJK" },
  { code: "+255", country: "Tanzania", iso3: "TZA" },
  { code: "+66", country: "Thailand", iso3: "THA" },
  { code: "+228", country: "Togo", iso3: "TGO" },
  { code: "+216", country: "Tunisia", iso3: "TUN" },
  { code: "+90", country: "Turkey", iso3: "TUR" },
  { code: "+993", country: "Turkmenistan", iso3: "TKM" },
  { code: "+256", country: "Uganda", iso3: "UGA" },
  { code: "+380", country: "Ukraine", iso3: "UKR" },
  { code: "+44", country: "United Kingdom", iso3: "GBR" },
  { code: "+1", country: "United States", iso3: "USA" },
  { code: "+598", country: "Uruguay", iso3: "URY" },
  { code: "+998", country: "Uzbekistan", iso3: "UZB" },
  { code: "+58", country: "Venezuela", iso3: "VEN" },
  { code: "+84", country: "Vietnam", iso3: "VNM" },
  { code: "+260", country: "Zambia", iso3: "ZMB" },
  { code: "+263", country: "Zimbabwe", iso3: "ZWE" },
];

export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Others" },
];

// Patient identity types (per Patient Info business rules document)
export const PATIENT_IDENTITY_TYPES = [
  { value: "National Number", label: "National Number" },
  { value: "Passport", label: "Passport" },
  { value: "Permanent Resident", label: "Permanent Resident" },
  { value: "Border Number", label: "Border Number" },
];

export const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "ar", label: "Arabic" },
];
